import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const integrationInit = {
    integrations: {},
    isLoadingIntegrations: false,
    datasets: [],
};

function integrationsReducer ( draft, { type, payload } ) {
    switch (type) {
        case 'setIntegrations': {
            const newState = {}
            for (let i = 0; i < payload.Integrations.length; i++) {
              let int = payload.Integrations[i]
              newState[int.id] = int
            }
            draft.integrations = newState
            break;
        }
        case 'setIsLoadingIntegrations': {
          draft.isLoadingIntegrations = payload
          break;
        }

        case 'setDatasets': {
            draft.datasets = payload;
            break;
        }
        default: {
            return null;
        }
    }
}

const [IntegrationsContext,IntegrationsDispatchContext] = [createContext(null),createContext(null)];

export default function IntegrationsProvider ({ init, children }) {
    const [integrationsStore, dispatch] = useImmerReducer(integrationsReducer, integrationInit);

    return (
        <IntegrationsContext.Provider value={init || integrationsStore}>
            <IntegrationsDispatchContext.Provider value={dispatch}>
                {children}
            </IntegrationsDispatchContext.Provider>
        </IntegrationsContext.Provider>
    )
}

export function useIntegrationsStore() {
    return useContext(IntegrationsContext);
}

export function useIntegrationsDispatch() {
    return useContext(IntegrationsDispatchContext);
}